import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
/**
 * Icon button atom.
 */
export class IconButtonComponent {
  private _disabled: boolean = false;
  private _v2: boolean = false;
  private _v2Delete: boolean = false;
  private _whiteBackground: boolean = false;
  private _borderless: boolean = false;

  @Input() icon?: string;
  @Input() formGroup?: UntypedFormGroup;
  @Output() clickAction = new EventEmitter<any>();

  /**
   * Whether this button is disabled or not
   */
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  /**
   * Sets this button as disabled
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set disabled(value: any) {
    this._disabled = coerceBooleanProperty(value);
  }

  /**
   * Emits click action event for underlying material button
   */
  emitClick() {
    this.clickAction.emit();
  }

  /**
   * If this button should be disabled or not
   * @return {boolean}
   */
  isDisabled(): boolean {
    return this.disabled || (Boolean(this.formGroup) && !this.formGroup?.valid);
  }

  /**
   * Whether is V2 or not
   */
  @Input()
  get v2(): boolean {
    return this._v2;
  }

  /**
   * Sets appearence as V2
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set v2(value: any) {
    this._v2 = coerceBooleanProperty(value);
  }

  /**
   * Whether is V2 Delete or not
   */
  @Input()
  get v2Delete(): boolean {
    return this._v2Delete;
  }

  /**
   * Sets appearence as V2 Delete
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set v2Delete(value: any) {
    this._v2Delete = coerceBooleanProperty(value);
  }

  /**
   * Whether is white background or not
   */
  @Input()
  get whiteBackground(): boolean {
    return this._whiteBackground;
  }

  /**
   * Sets appearence as white background
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set whiteBackground(value: any) {
    this._whiteBackground = coerceBooleanProperty(value);
  }

  /**
   * Whether is borderless or not
   */
  @Input()
  get borderless(): boolean {
    return this._borderless;
  }

  /**
   * Sets appearence as borderless
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set borderless(value: any) {
    this._borderless = coerceBooleanProperty(value);
  }
}
